import { Component } from "@builder.io/sdk";

export const careersFAQsConfig: Component = {
  name: "Careers FAQs",
  inputs: [
    {
      name: "heading",
      type: "string",
      defaultValue: "Frequently Asked Questions",
      helperText: "Section heading text",
      advanced: false,
    },
    {
      name: "subheading",
      type: "string",
      defaultValue:
        "Find Out How We Support Caregivers and Nurses Across the Bay Area",
      helperText: "Subheading text displayed below the main heading",
      advanced: false,
    },
    {
      name: "items",
      type: "list",
      defaultValue: [
        {
          header: "What Benefits does Care Indeed Offer?",
          headerClassName: "bg-primary-100",
          content:
            "<p>Full-time employees have the option to enroll in Medical, Dental, Vision, or Life Insurance. We also provide 401k matching</p>",
          defaultOpen: false,
        },
        {
          header: "What is your mode of payment?",
          headerClassName: "bg-primary-100",
          content: "<p>We pay weekly via direct deposit or physical check.</p>",
          defaultOpen: false,
        },
        {
          header: "Will I get paid for my application process?",
          headerClassName: "bg-primary-100",
          content:
            "<p>You will get paid after completing the whole hiring process. After finishing your New Hire Workshop, you will be paid for the duration of training.</p>",
          defaultOpen: false,
        },
        {
          header: "What hours can I expect to work?",
          headerClassName: "bg-primary-100",
          content:
            "<p>We offer flexible scheduling options, including part-time and full-time positions. Some roles may require 24/7 availability or overnight shifts. Discuss your availability with our hiring team to find a schedule that works for you.</p>",
          defaultOpen: false,
        },
        {
          header:
            "When will I start getting shifts/calls for possible clients?",
          headerClassName: "bg-primary-100",
          content:
            "<p>After your New Hire Workshop is completed, our Staffing Team will connect you with potential clients that will match your skills, background, availability and preferences.</p>",
          defaultOpen: false,
        },
        {
          header: "Am I required to have a Home Care Aide ID?",
          headerClassName: "bg-primary-100",
          content:
            "<p>Yes, it is a state-mandated requirement and is one of the requirements we look for in our applicants. If you do not have it, we can help you register. For more information, you can check CDSS at <a href='https://www.ccld.dss.ca.gov/hcsregistry' target='_blank' rel='noopener noreferrer'>www.ccld.dss.ca.gov/hcsregistry</a>.</p>",
          defaultOpen: false,
        },
        {
          header:
            "Can I start working as a Home Care Aide and then transfer to a Certified Nursing Assistant once I obtain my license?",
          headerClassName: "bg-primary-100",
          content:
            "<p>Yes! We encourage and support career growth; even from Home Care to Home Health!</p>",
          defaultOpen: false,
        },
        {
          header:
            "What employee authorization documents do I need to start working?",
          headerClassName: "bg-primary-100",
          content:
            "<p>We need documents for your I-9. You can check the list of accepted documents here: <a href='https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents' target='_blank' rel='noopener noreferrer'>https://www.uscis.gov/i-9-central/form-i-9-acceptable-documents</a>.</p>",
          defaultOpen: false,
        },
        {
          header:
            "Does Care Indeed offer training for inexperienced applicants?",
          headerClassName: "bg-primary-100",
          content: "<p>Yes, we offer virtual and on-site paid training.</p>",
          defaultOpen: false,
        },
        {
          header: "How many hours is a typical shift?",
          headerClassName: "bg-primary-100",
          content:
            "<p>We offer shifts ranging from 4-12 hours, depending on the need.</p>",
          defaultOpen: false,
        },
        {
          header: "Is there room for career growth and advancement?",
          headerClassName: "bg-primary-100",
          content:
            "<p>Absolutely! We encourage professional development and offer opportunities for career advancement. You may pursue additional certifications, specialize in specific areas of care, or move into supervisory or management roles as you gain experience.</p>",
          defaultOpen: false,
        },
        {
          header: "How do you match caregivers with clients?",
          headerClassName: "bg-primary-100",
          content:
            "<p>We carefully assess both caregiver skills and client needs to ensure the best possible match. Factors considered include experience, specializations, personality, and scheduling preferences.</p>",
          defaultOpen: false,
        },
        {
          header: "How long does the hiring process take?",
          headerClassName: "bg-primary-100",
          content:
            "<p>We aim to have our caregivers finish their application before or after their application process, giving them enough time to complete the requirements and trainings that they would need.</p>",
          defaultOpen: false,
        },
      ],
      subFields: [
        {
          name: "header",
          type: "string",
          required: true,
          helperText: "The question or header text for this accordion item",
        },
        {
          name: "content",
          type: "richText",
          required: true,
          helperText: "The answer or content for this accordion item",
        },
        {
          name: "defaultOpen",
          type: "boolean",
          required: false,
          defaultValue: false,
          helperText: "Whether this accordion item should be open by default",
          advanced: true,
        },
        {
          name: "className",
          type: "string",
          required: false,
          helperText: "Custom CSS class name for the entire accordion item",
          advanced: true,
        },
        {
          name: "headerClassName",
          type: "string",
          required: false,
          helperText: "Custom CSS class name for the header/question section",
          advanced: true,
        },
        {
          name: "contentClassName",
          type: "string",
          required: false,
          helperText: "Custom CSS class name for the content/answer section",
          advanced: true,
        },
      ],
      helperText: "Questions and answers for the FAQ section",
      advanced: false,
    },
    {
      name: "id",
      type: "string",
      defaultValue: "careers-faqs",
      helperText: "Section ID for navigation",
      advanced: true,
    },
  ],
};
